import React from 'react';
import { useLocation } from 'react-router-dom';
import { Text } from '../../styles/typography';

interface StepTextProps {
  currentStep: number;
  style?: React.CSSProperties;
}

const StepText: React.FC<StepTextProps> = ({ currentStep, style }) => {
  const location = useLocation();
  const hasAppParam = location.search.includes('app');
  const totalSteps = hasAppParam ? 6 : 5;
  const stepNumber = hasAppParam ? currentStep : currentStep - 1;

  return (
    <Text style={{ marginTop: 0, marginBottom: 5, ...style }}>
      {stepNumber}/{totalSteps}
    </Text>
  );
};

export default StepText;
